import ym from 'react-yandex-metrika';

export function getError(error) {
    ym('reachGoal', 'get_error', { "error_message": error });
}

export function openMainPage() {
    ym('reachGoal', 'open_main_page');
}

export function openBlogPage() {
    ym('reachGoal', 'open_blog_page');
}

export function openDashboardPage() {
    ym('reachGoal', 'open_dashboard_page');
}

export function openGamePage() {
    ym('reachGoal', 'open_game_page');
}

export function clickConnectAccount() {
    ym('reachGoal', 'click_connect_account');
}

export function clickMint() {
    ym('reachGoal', 'click_mint');
}

export function clickPlay() {
    ym('reachGoal', 'click_play');
}

export function clickStartGame() {
    ym('reachGoal', 'click_start_game');
}

export function clickSavePlayerScore() {
    ym('reachGoal', 'click_save_player_score');
}

export function clickSubmitIdea() {
    ym('reachGoal', 'click_submit_idea');
}

export function clickSubmitDecision() {
    ym('reachGoal', 'click_submit_decision');
}

export function clickChangeNickname() {
    ym('reachGoal', 'click_change_nickname');
}

export function clickOpenDiscord() {
    ym('reachGoal', 'click_open_discord');
}

export function clickOpenTwitter() {
    ym('reachGoal', 'click_open_twitter');
}

export function connectAccount(account) {
    ym('reachGoal', 'connect_account', { "account_address": account });
}

export function mint() {
    ym('reachGoal', 'mint');
}